const enabled = true

/**
 * This is a helper function to log the names of pre-bundled script files for pages.
 * @param {JQuery element} $element The element on which the script depends
 * @param {string} script The name of the script file
 */
export default function($element, script) {
  let shouldLog = $element instanceof jQuery ? $element.length : $element
  if (process.env.NODE_ENV === 'development' && enabled && shouldLog)
    console.log(`%c ${script}`, 'background: #222; color: #bada55')
}
